import { withErrorBoundary } from 'shared'
import { TopLevelPage }      from 'ui'
import { Backend }           from 'base'
import { Spinner }           from 'shared'
import { useEffect, useState } from 'react'

const FranCardEditor = ({ amount, date, reservationId, serviceId, time }) => {

  // State
  const [state, setState] = useState({})

  // Consts

  // Hooks
  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    let mobParams = location.hash.split('?').pop()
    let param = amount ? `${reservationId.split(':')[0]}_id=${reservationId}&amount=${amount}&date=${date}&time=${time}&service_id=${serviceId}` : reservationId.includes('sb:') ? `smart_button_id=${reservationId}&amount_p=${location.hash.split('/').pop()}` :`${reservationId.split(':')[0]}_id=${reservationId}`
    let newPath = ''
    if (mobParams.includes('mobile')) {
      param = `${param}&${mobParams}`
      newPath = reservationId ? `/profile/credit_cards?${param}` : `/profile/credit_cards?${mobParams}`
    } else {
      newPath = reservationId ? `/profile/credit_cards?${param}` : '/profile/credit_cards'
    }
    let path = newPath
    let { fran_token } = await Backend.get(path)
    console.log('Fran Token: ', fran_token)
    setState({ token: fran_token })
  }

  return (
    <TopLevelPage className="row">
      {
        state.token == null ? <Spinner /> :
        <iframe src={state.token} name="iframe_a" height="400px" width="100%" title="Iframe Example">Add</iframe>
      }
    </TopLevelPage>
  )
}

export default withErrorBoundary(FranCardEditor)
